/** Greek review copy. Company facts/demo identities remain unconfirmed. English source strings are stable message IDs. */
export const greek=Object.freeze({
  "Read our approach": "Δείτε την προσέγγισή μας",
  "Main navigation": "Κύρια πλοήγηση",
  "Pegasoft home": "Αρχική σελίδα Pegasoft",
  "About": "Σχετικά με εμάς",
  "Expertise": "Τεχνογνωσία",
  "Industries": "Κλάδοι",
  "Insights": "Άρθρα",
  "Careers": "Καριέρα",
  "Contact": "Επικοινωνία",
  "Menu": "Μενού",
  "Let’s talk": "Ας μιλήσουμε",
  "Language": "Γλώσσα",
  "Opening and outcomes": "Εισαγωγή και αποτελέσματα",
  "Live rotating globe with geographic land dots and blue raised connection arcs": "Περιστρεφόμενη υδρόγειος με γεωγραφικά σημεία και μπλε τόξα συνδέσεων",
  "One accountable team": "Μία ομάδα με ευθύνη για το αποτέλεσμα",
  "Every idea": "Κάθε ιδέα",
  "Engineered": "Φτιαγμένη",
  "to matter.": "να μετράει.",
  "ship.engineered": "Τεχνικές",
  "Strategy, design and engineering,": "Στρατηγική, σχεδιασμός και ανάπτυξη,",
  "carried through by one accountable team.": "από μία ομάδα με ευθύνη για το αποτέλεσμα.",
  "Talk with us": "Μιλήστε μαζί μας",
  "Our services": "Οι υπηρεσίες μας",
  "Outcome chapter": "Ενότητα αποτελεσμάτων",
  "Built with accountability": "Με ευθύνη για το αποτέλεσμα",
  "We build": "Χτίζουμε",
  "technology.": "τεχνολογία.",
  "We own": "Αναλαμβάνουμε",
  "the outcome.": "το αποτέλεσμα.",
  "Strategy, design and engineering.": "Στρατηγική, σχεδιασμός και ανάπτυξη.",
  "Connected from the first idea onward.": "Μαζί, από την πρώτη ιδέα και σε κάθε επόμενο βήμα.",
  "Years of delivery": "Χρόνια υλοποίησης",
  "From discovery through design, engineering and launch.": "Από τη διερεύνηση και τον σχεδιασμό έως την ανάπτυξη και τη διάθεση.",
  "98.5%": "98,5%",
  "Conversion rate": "Ποσοστό μετατροπών",
  "An illustrative measure for a complete digital journey.": "Ενδεικτική μέτρηση για μια ολοκληρωμένη ψηφιακή εμπειρία.",
  "Clients worldwide": "Πελάτες διεθνώς",
  "Digital products and platforms across complex industries.": "Ψηφιακά προϊόντα και πλατφόρμες σε κλάδους με σύνθετες απαιτήσεις.",
  "Countries": "Χώρες",
  "Connected delivery across markets and teams.": "Συντονισμένη υλοποίηση σε διαφορετικές αγορές και ομάδες.",
  "Projects completed": "Ολοκληρωμένα έργα",
  "Product experiences, systems and integrations.": "Ψηφιακές εμπειρίες, συστήματα και διασυνδέσεις.",
  "Our journey": "Η διαδρομή μας",
  "Preparing the journey…": "Προετοιμάζουμε τη διαδρομή…",
  "OUR SERVICES": "ΟΙ ΥΠΗΡΕΣΙΕΣ ΜΑΣ",
  "Services chapter overlay": "Ενότητα υπηρεσιών",
  "Everything your product needs. One team.": "Όσα χρειάζεται το προϊόν σας. Μία ομάδα.",
  "Strategy, design and engineering, carried through by one accountable team.": "Στρατηγική, σχεδιασμός και ανάπτυξη, από μία ομάδα με ευθύνη για το αποτέλεσμα.",
  "Product strategy": "Στρατηγική προϊόντος",
  "Research, product direction and delivery priorities.": "Έρευνα, κατεύθυνση προϊόντος και προτεραιότητες υλοποίησης.",
  "UX/UI design": "Σχεδιασμός UX/UI",
  "Journeys, interfaces and design systems.": "Διαδρομές χρηστών, διεπαφές και συστήματα σχεδιασμού.",
  "Web engineering": "Ανάπτυξη εφαρμογών web",
  "Web experiences and connected product systems.": "Εμπειρίες web και διασυνδεδεμένα συστήματα προϊόντων.",
  "Mobile applications": "Εφαρμογές για κινητά",
  "Mobile interfaces and application engineering.": "Διεπαφές για κινητά και ανάπτυξη εφαρμογών.",
  "AI & automation": "Τεχνητή νοημοσύνη & αυτοματισμοί",
  "Connected workflows, useful AI and automation.": "Συνδεδεμένες ροές εργασίας, χρήσιμη τεχνητή νοημοσύνη και αυτοματισμοί.",
  "Cloud & platform engineering": "Υποδομές cloud & πλατφόρμες",
  "Cloud foundations, integrations and product operations.": "Υποδομές cloud, διασυνδέσεις και λειτουργία προϊόντων.",
  "Road chapter": "Ενότητα οδικής διαδρομής",
  "Precision": "Ακρίβεια",
  "at every milestone.": "σε κάθε ορόσημο.",
  "Visible progress": "Ορατή πρόοδος",
  "Clear priorities and delivery checkpoints.": "Σαφείς προτεραιότητες και ορόσημα υλοποίησης.",
  "Integrated delivery": "Ενιαία υλοποίηση",
  "Strategy, design and engineering together.": "Στρατηγική, σχεδιασμός και ανάπτυξη μαζί.",
  "Ongoing evolution": "Συνεχής εξέλιξη",
  "Continued improvements as your product grows.": "Συνεχείς βελτιώσεις καθώς το προϊόν σας εξελίσσεται.",
  "Built to work at scale": "Σχεδιασμένο για να εξελίσσεται",
  "Built to work": "Σχεδιασμένο",
  "at scale.": "για εξέλιξη.",
  "One accountable": "Μία υπεύθυνη",
  "team": "ομάδα",
  "Clear project": "Πλήρης εικόνα",
  "visibility": "του έργου",
  "Shared priorities and delivery checkpoints.": "Κοινές προτεραιότητες και ορόσημα υλοποίησης.",
  "foundations": "βάσεις",
  "Connected product systems.": "Διασυνδεδεμένα συστήματα προϊόντων.",
  "Transparent": "Ξεκάθαρο",
  "scope": "αντικείμενο",
  "Clear decisions throughout delivery.": "Σαφείς αποφάσεις σε κάθε στάδιο υλοποίησης.",
  "Fast decisions": "Γρήγορες αποφάσεις",
  "Keep the next step visible.": "Το επόμενο βήμα είναι πάντα ξεκάθαρο.",
  "Pegasoft trust chapter": "Ενότητα εμπιστοσύνης της Pegasoft",
  "Trusted": "Εμπιστοσύνη",
  "to build what": "για όσα",
  "comes next.": "έρχονται.",
  "We bring clarity to complex challenges, shaping purposeful digital experiences.": "Δίνουμε σαφήνεια σε σύνθετες προκλήσεις και δημιουργούμε ψηφιακές εμπειρίες με ουσία.",
  "Precision in every detail.": "Ακρίβεια σε κάθε λεπτομέρεια.",
  "What they say": "Τι λένε για εμάς",
  "Previous testimonial": "Προηγούμενη μαρτυρία",
  "Next testimonial": "Επόμενη μαρτυρία",
  "Demo client testimonials. Use left and right arrow keys to browse.": "Ενδεικτικές μαρτυρίες πελατών. Χρησιμοποιήστε το αριστερό και το δεξί βέλος για περιήγηση.",
  "A shared direction, from the first conversation.": "Κοινή κατεύθυνση, από την πρώτη συζήτηση.",
  "The team helped us turn a complicated product brief into a clear plan. Design and engineering stayed connected as the work took shape.": "Η ομάδα μάς βοήθησε να μετατρέψουμε σύνθετες απαιτήσεις σε ένα ξεκάθαρο πλάνο. Ο σχεδιασμός και η ανάπτυξη παρέμειναν συντονισμένα σε όλη την πορεία.",
  "Product lead · fictional company": "Υπεύθυνος προϊόντος · φανταστική εταιρεία",
  "Built together, with room to think.": "Μαζί στην υλοποίηση, με χώρο για σκέψη.",
  "We could follow the decisions, ask questions and understand the tradeoffs. The collaboration felt like one team working toward the same release.": "Είχαμε εικόνα των αποφάσεων, μπορούσαμε να ρωτάμε και να κατανοούμε τις επιλογές. Η συνεργασία έμοιαζε με μία ομάδα που εργαζόταν για τον ίδιο στόχο.",
  "Technology lead · fictional company": "Υπεύθυνος τεχνολογίας · φανταστική εταιρεία",
  "Clarity at every step.": "Σαφήνεια σε κάθε βήμα.",
  "Regular conversations kept our priorities visible. Each milestone gave us something tangible to review and a clear sense of what came next.": "Οι τακτικές συζητήσεις κρατούσαν τις προτεραιότητές μας ξεκάθαρες. Κάθε ορόσημο έφερνε κάτι χειροπιαστό για αξιολόγηση και σαφή εικόνα για τη συνέχεια.",
  "Operations lead · fictional company": "Υπεύθυνος λειτουργιών · φανταστική εταιρεία",
  "A product that feels considered.": "Ένα προϊόν με φροντίδα σε κάθε λεπτομέρεια.",
  "The experience brought our ideas into focus. Small details received the same attention as the larger system, from the first prototype to the final screens.": "Η εμπειρία έδωσε μορφή στις ιδέες μας. Οι μικρές λεπτομέρειες είχαν την ίδια προσοχή με το συνολικό σύστημα, από το πρώτο πρωτότυπο έως τις τελικές οθόνες.",
  "Founder · fictional company": "Ιδρυτής · φανταστική εταιρεία",
  "Pegasoft jet": "Αεροσκάφος Pegasoft",
  "Our approach": "Η προσέγγισή μας",
  "Every idea. Engineered to matter.": "Κάθε ιδέα. Φτιαγμένη να μετράει.",
  "We build technology. We own the outcome.": "Χτίζουμε τεχνολογία. Αναλαμβάνουμε το αποτέλεσμα.",
  "Illustrative metrics": "Ενδεικτικές μετρήσεις",
  "Illustrative figures": "Ενδεικτικά στοιχεία",
  "2+ years of delivery": "2+ χρόνια υλοποίησης",
  "98.5% conversion rate": "98,5% ποσοστό μετατροπών",
  "15+ clients worldwide": "15+ πελάτες διεθνώς",
  "5+ countries": "5+ χώρες",
  "50+ projects completed": "50+ ολοκληρωμένα έργα",
  "Pegasoft container ship": "Πλοίο μεταφοράς εμπορευματοκιβωτίων Pegasoft",
  "Built to work at scale.": "Σχεδιασμένο για να εξελίσσεται.",
  "Clear project visibility": "Πλήρης εικόνα του έργου",
  "Engineered foundations": "Ισχυρές τεχνικές βάσεις",
  "Transparent scope": "Ξεκάθαρο αντικείμενο",
  "Talk with us ↗": "Μιλήστε μαζί μας ↗",
  "Connections": "Συνεργασίες",
  "that move us forward.": "που μας πάνε μπροστά.",
  "Illustrative partner identities across connected industries. Replace these placeholders with authorized names and marks.": "Ενδεικτικές ταυτότητες συνεργατών από συναφείς κλάδους. Θα αντικατασταθούν από εγκεκριμένες επωνυμίες και σήματα.",
  "Pause partner motion": "Παύση κίνησης συνεργατών",
  "Resume partner motion": "Συνέχιση κίνησης συνεργατών",
  "Fictional partner wall": "Τοίχος ενδεικτικών συνεργατών",
  "Fintech": "Χρηματοοικονομική τεχνολογία",
  "Fictional placeholder": "Ενδεικτική φανταστική ταυτότητα",
  "Digital banking": "Ψηφιακή τραπεζική",
  "Trade & transit": "Εμπόριο & διαμετακόμιση",
  "Health & wellness": "Υγεία & ευεξία",
  "Telecom": "Τηλεπικοινωνίες",
  "Booking systems": "Συστήματα κρατήσεων",
  "Education": "Εκπαίδευση",
  "Cloud services": "Υπηρεσίες cloud",
  "Digital products": "Ψηφιακά προϊόντα",
  "Commerce": "Εμπορικές συναλλαγές",
  "Platforms": "Πλατφόρμες",
  "Data systems": "Συστήματα δεδομένων",
  "Mobile products": "Προϊόντα για κινητά",
  "Public services": "Δημόσιες υπηρεσίες",
  "Connected systems": "Διασυνδεδεμένα συστήματα",
  "What’s next": "Το επόμενο βήμα",
  "in technology.": "στην τεχνολογία.",
  "Perspectives on connected systems, purposeful AI and digital craft.": "Ιδέες για συνδεδεμένα συστήματα, χρήσιμη τεχνητή νοημοσύνη και προσεγμένη ψηφιακή δημιουργία.",
  "Explore perspectives ↗": "Δείτε τα άρθρα ↗",
  "Product systems": "Συστήματα προϊόντων",
  "Connected product systems": "Διασυνδεδεμένα συστήματα προϊόντων",
  "Purposeful AI": "Τεχνητή νοημοσύνη με ουσία",
  "Design & engineering": "Σχεδιασμός & ανάπτυξη",
  "Digital craft": "Ψηφιακή δημιουργία",
  "Selected perspective image": "Εικόνα επιλεγμένου άρθρου",
  "Pegasoft ship — connected product systems": "Πλοίο Pegasoft — διασυνδεδεμένα συστήματα προϊόντων",
  "Pegasoft atmosphere — purposeful AI": "Ατμόσφαιρα Pegasoft — τεχνητή νοημοσύνη με ουσία",
  "Pegasoft aircraft — digital craft": "Αεροσκάφος Pegasoft — ψηφιακή δημιουργία",
  "Good questions.": "Εύστοχες ερωτήσεις.",
  "Clear answers.": "Ξεκάθαρες απαντήσεις.",
  "Draft answers for the final content review.": "Προτεινόμενες απαντήσεις προς τελική αξιολόγηση περιεχομένου.",
  "What can Pegasoft help us build?": "Τι μπορεί να υλοποιήσει για εμάς η Pegasoft;",
  "The proposed capabilities cover product strategy, UX/UI design, web and mobile engineering, AI and automation, and cloud platforms.": "Οι προτεινόμενες υπηρεσίες καλύπτουν τη στρατηγική προϊόντος, τον σχεδιασμό UX/UI, την ανάπτυξη εφαρμογών web και κινητών, την τεχνητή νοημοσύνη, τους αυτοματισμούς και τις πλατφόρμες cloud.",
  "How does a project start?": "Πώς ξεκινά ένα έργο;",
  "Start with a conversation about the problem, your users and the outcome you want. Discovery can then define priorities and the first delivery milestone.": "Ξεκινάμε με μια συζήτηση για την πρόκληση, τους χρήστες και το επιθυμητό αποτέλεσμα. Η διερεύνηση καθορίζει τις προτεραιότητες και το πρώτο ορόσημο υλοποίησης.",
  "How is the timeline agreed?": "Πώς συμφωνείται το χρονοδιάγραμμα;",
  "Scope, integrations and dependencies determine the delivery plan. Milestones and review points are agreed before work begins.": "Το αντικείμενο, οι διασυνδέσεις και οι εξαρτήσεις καθορίζουν το πλάνο υλοποίησης. Τα ορόσημα και τα σημεία αξιολόγησης συμφωνούνται πριν ξεκινήσουν οι εργασίες.",
  "How do we stay involved?": "Πώς συμμετέχουμε στην πορεία του έργου;",
  "The proposed collaboration model uses shared priorities, visible progress and regular reviews so decisions stay close to the work.": "Το προτεινόμενο μοντέλο συνεργασίας βασίζεται σε κοινές προτεραιότητες, ορατή πρόοδο και τακτικές αξιολογήσεις, ώστε οι αποφάσεις να συνδέονται άμεσα με την υλοποίηση.",
  "Who owns the source code?": "Σε ποιον ανήκει ο πηγαίος κώδικας;",
  "Ownership, source access and licensing are agreed in the project contract.": "Η κυριότητα, η πρόσβαση στον πηγαίο κώδικα και οι άδειες χρήσης συμφωνούνται στη σύμβαση του έργου.",
  "What happens after launch?": "Τι γίνεται μετά τη διάθεση του προϊόντος;",
  "Support, availability and ongoing development are scoped and agreed separately.": "Η υποστήριξη, η διαθεσιμότητα και η περαιτέρω ανάπτυξη καθορίζονται και συμφωνούνται ξεχωριστά.",
  "Ready to build": "Έτοιμοι να χτίσουμε",
  "what’s next?": "το επόμενο βήμα;",
  "One accountable team.": "Μία ομάδα με ευθύνη για το αποτέλεσμα.",
  "Talk": "Μιλήστε",
  "with us": "μαζί μας",
  "Footer navigation": "Πλοήγηση υποσέλιδου",
  "FAQ": "Συχνές ερωτήσεις",
  "Let’s build": "Ας δημιουργήσουμε",
  "Explore industries or services": "Εξερεύνηση κλάδων ή υπηρεσιών",
  "Services": "Υπηρεσίες",
  "Industries and services": "Κλάδοι και υπηρεσίες",
  "Let’s talk.": "Ας μιλήσουμε.",
  "Build what’s next.": "Ας χτίσουμε το επόμενο βήμα.",
  "Tell us what you’re building.": "Πείτε μας τι θέλετε να δημιουργήσετε.",
  "Email, office location and legal identity await confirmation.": "Το email, η έδρα και τα νομικά στοιχεία αναμένουν επιβεβαίωση.",
  "Contact audience": "Κατηγορία επικοινωνίας",
  "General": "Γενικά",
  "Company owner": "Ιδιοκτήτης επιχείρησης",
  "Investor": "Επενδυτής",
  "Review prototype. Messages are not sent. Recipient, privacy wording and the submission endpoint await confirmation.": "Πρωτότυπο αξιολόγησης. Δεν αποστέλλονται μηνύματα. Ο παραλήπτης, το κείμενο απορρήτου και το σημείο υποβολής αναμένουν επιβεβαίωση.",
  "Company and legal details pending confirmation.": "Τα εταιρικά και νομικά στοιχεία αναμένουν επιβεβαίωση.",
  "Your privacy matters": "Το απόρρητό σας έχει σημασία",
  "We use essential site features to remember your preferences. No optional analytics or marketing trackers are enabled.": "Χρησιμοποιούμε απαραίτητες λειτουργίες για να θυμόμαστε τις προτιμήσεις σας. Δεν είναι ενεργή προαιρετική παρακολούθηση για ανάλυση ή μάρκετινγκ.",
  "Reject all": "Απόρριψη όλων",
  "Accept all": "Αποδοχή όλων",
  "Preferences apply to this visit only. This browser could not save them.": "Οι προτιμήσεις ισχύουν μόνο για αυτή την επίσκεψη. Το πρόγραμμα περιήγησης δεν μπόρεσε να τις αποθηκεύσει.",
  "Cookie preferences": "Προτιμήσεις cookies",
  "No optional analytics or marketing trackers are connected in this preview.": "Δεν έχουν συνδεθεί προαιρετικοί μηχανισμοί ανάλυσης ή μάρκετινγκ σε αυτή την προεπισκόπηση.",
  "Essential site features": "Απαραίτητες λειτουργίες ιστοτόπου",
  "This preference is stored locally. No optional tracking category is enabled.": "Η προτίμηση αποθηκεύεται τοπικά. Δεν ενεργοποιείται προαιρετική κατηγορία παρακολούθησης.",
  "Save preferences": "Αποθήκευση προτιμήσεων",
  "Close": "Κλείσιμο",
  "Pegasoft wordmark. Move the cursor to disperse the dots; pause to reform.": "Λογότυπο Pegasoft με κουκκίδες. Μετακινήστε τον δείκτη για διασπορά και σταματήστε για επανασύνθεση.",
  "Explore Pegasoft": "Εξερευνήστε την Pegasoft",
  "Mobile navigation": "Πλοήγηση για κινητά",
  "Booking & education": "Κρατήσεις & εκπαίδευση",
  "Cloud & platform": "Cloud & πλατφόρμες",
  "Name": "Ονοματεπώνυμο",
  "Email": "Email",
  "Company (optional)": "Εταιρεία (προαιρετικό)",
  "Message": "Μήνυμα",
  "Business email": "Επαγγελματικό email",
  "Company / website": "Εταιρεία / ιστότοπος",
  "Project goals": "Στόχοι έργου",
  "Firm": "Εταιρεία / οργανισμός",
  "Investment interest": "Επενδυτικό ενδιαφέρον",
  "Mobile (optional)": "Κινητό τηλέφωνο (προαιρετικό)",
  "Role of interest": "Θέση ενδιαφέροντος",
  "CV / résumé": "Βιογραφικό",
  "Other links to your work (optional)": "Πρόσθετοι σύνδεσμοι προς τη δουλειά σας (προαιρετικό)",
  "Select a role": "Επιλέξτε θέση",
  "Frontend software engineer": "Μηχανικός λογισμικού Frontend",
  "Backend software engineer": "Μηχανικός λογισμικού Backend",
  "Fullstack software engineer": "Μηχανικός λογισμικού Fullstack",
  "DevOps engineer": "Μηχανικός DevOps",
  "Sales specialist": "Στέλεχος πωλήσεων",
  "Operations specialist": "Στέλεχος λειτουργιών",
  "Administrator": "Στέλεχος διοικητικής υποστήριξης",
  "Business specialist": "Στέλεχος επιχειρηματικής ανάπτυξης",
  "Project manager": "Υπεύθυνος έργων",
  "Other": "Άλλη θέση",
  "No file selected": "Δεν έχει επιλεγεί αρχείο",
  "Drop your CV here": "Σύρετε εδώ το βιογραφικό σας",
  "or choose a file": "ή επιλέξτε αρχείο",
  "Remove CV": "Αφαίρεση βιογραφικού",
  "Review prototype: the file stays local and is not uploaded.": "Πρωτότυπο αξιολόγησης: το αρχείο παραμένει τοπικά και δεν μεταφορτώνεται.",
  "GitHub, portfolio, LinkedIn or other links — one per line": "GitHub, portfolio, LinkedIn ή άλλοι σύνδεσμοι — ένας ανά γραμμή",
  "Review application": "Έλεγχος αίτησης",
  "Review message": "Έλεγχος μηνύματος",
  "Application draft validated. Your CV stays in this browser; nothing has been sent.": "Το προσχέδιο αίτησης ελέγχθηκε. Το βιογραφικό παραμένει σε αυτό το πρόγραμμα περιήγησης· δεν έχει αποσταλεί τίποτα.",
  "Draft validated. Nothing has been sent; the submission endpoint is not connected.": "Το προσχέδιο ελέγχθηκε. Δεν έχει αποσταλεί τίποτα· το σημείο υποβολής δεν είναι συνδεδεμένο.",
  "Preferences saved. No optional trackers enabled.": "Οι προτιμήσεις αποθηκεύτηκαν. Δεν ενεργοποιήθηκαν προαιρετικοί μηχανισμοί παρακολούθησης.",
  "Preferences could not be stored in this browser. No optional trackers enabled.": "Δεν ήταν δυνατή η αποθήκευση προτιμήσεων σε αυτό το πρόγραμμα περιήγησης. Δεν ενεργοποιήθηκαν προαιρετικοί μηχανισμοί παρακολούθησης.",
  "Please complete this field.": "Συμπληρώστε αυτό το πεδίο.",
  "Please enter a valid email address.": "Εισαγάγετε μια έγκυρη διεύθυνση email.",
  "Pegasoft — Every idea engineered to matter.": "Pegasoft — Κάθε ιδέα, φτιαγμένη να μετράει.",
  "Pegasoft — strategy, design and engineering together.": "Pegasoft — Στρατηγική, σχεδιασμός και ανάπτυξη μαζί.",
  "Partner 01": "Συνεργάτης 01",
  "Demo partner 01, Fintech, fictional placeholder": "Ενδεικτικός συνεργάτης 01, Χρηματοοικονομική τεχνολογία, φανταστική ταυτότητα",
  "Partner 02": "Συνεργάτης 02",
  "Demo partner 02, Digital banking, fictional placeholder": "Ενδεικτικός συνεργάτης 02, Ψηφιακή τραπεζική, φανταστική ταυτότητα",
  "Partner 03": "Συνεργάτης 03",
  "Demo partner 03, Trade & transit, fictional placeholder": "Ενδεικτικός συνεργάτης 03, Εμπόριο & διαμετακόμιση, φανταστική ταυτότητα",
  "Partner 04": "Συνεργάτης 04",
  "Demo partner 04, Health & wellness, fictional placeholder": "Ενδεικτικός συνεργάτης 04, Υγεία & ευεξία, φανταστική ταυτότητα",
  "Partner 05": "Συνεργάτης 05",
  "Demo partner 05, Telecom, fictional placeholder": "Ενδεικτικός συνεργάτης 05, Τηλεπικοινωνίες, φανταστική ταυτότητα",
  "Partner 06": "Συνεργάτης 06",
  "Demo partner 06, Booking systems, fictional placeholder": "Ενδεικτικός συνεργάτης 06, Συστήματα κρατήσεων, φανταστική ταυτότητα",
  "Partner 07": "Συνεργάτης 07",
  "Demo partner 07, Education, fictional placeholder": "Ενδεικτικός συνεργάτης 07, Εκπαίδευση, φανταστική ταυτότητα",
  "Partner 08": "Συνεργάτης 08",
  "Demo partner 08, Cloud services, fictional placeholder": "Ενδεικτικός συνεργάτης 08, Υπηρεσίες cloud, φανταστική ταυτότητα",
  "Partner 09": "Συνεργάτης 09",
  "Demo partner 09, Digital products, fictional placeholder": "Ενδεικτικός συνεργάτης 09, Ψηφιακά προϊόντα, φανταστική ταυτότητα",
  "Partner 10": "Συνεργάτης 10",
  "Demo partner 10, Commerce, fictional placeholder": "Ενδεικτικός συνεργάτης 10, Εμπορικές συναλλαγές, φανταστική ταυτότητα",
  "Partner 11": "Συνεργάτης 11",
  "Demo partner 11, Platforms, fictional placeholder": "Ενδεικτικός συνεργάτης 11, Πλατφόρμες, φανταστική ταυτότητα",
  "Partner 12": "Συνεργάτης 12",
  "Demo partner 12, Data systems, fictional placeholder": "Ενδεικτικός συνεργάτης 12, Συστήματα δεδομένων, φανταστική ταυτότητα",
  "Partner 13": "Συνεργάτης 13",
  "Demo partner 13, Mobile products, fictional placeholder": "Ενδεικτικός συνεργάτης 13, Προϊόντα για κινητά, φανταστική ταυτότητα",
  "Partner 14": "Συνεργάτης 14",
  "Demo partner 14, Public services, fictional placeholder": "Ενδεικτικός συνεργάτης 14, Δημόσιες υπηρεσίες, φανταστική ταυτότητα",
  "Partner 15": "Συνεργάτης 15",
  "Demo partner 15, Connected systems, fictional placeholder": "Ενδεικτικός συνεργάτης 15, Διασυνδεδεμένα συστήματα, φανταστική ταυτότητα",
  "Demo metric · 01": "Ενδεικτική μέτρηση · 01",
  "Demo metric · 02": "Ενδεικτική μέτρηση · 02",
  "Demo metric · 03": "Ενδεικτική μέτρηση · 03",
  "Demo metric · 04": "Ενδεικτική μέτρηση · 04",
  "Demo metric · 05": "Ενδεικτική μέτρηση · 05",
  "Demo client 01": "Ενδεικτικός πελάτης 01",
  "Demo testimonial 01": "Ενδεικτική μαρτυρία 01",
  "Illustrated dummy avatar 1": "Ενδεικτική εικονογράφηση προσώπου 1",
  "Demo client 02": "Ενδεικτικός πελάτης 02",
  "Demo testimonial 02": "Ενδεικτική μαρτυρία 02",
  "Illustrated dummy avatar 2": "Ενδεικτική εικονογράφηση προσώπου 2",
  "Demo client 03": "Ενδεικτικός πελάτης 03",
  "Demo testimonial 03": "Ενδεικτική μαρτυρία 03",
  "Illustrated dummy avatar 3": "Ενδεικτική εικονογράφηση προσώπου 3",
  "Demo client 04": "Ενδεικτικός πελάτης 04",
  "Demo testimonial 04": "Ενδεικτική μαρτυρία 04",
  "Illustrated dummy avatar 4": "Ενδεικτική εικονογράφηση προσώπου 4",
  "Pegasoft": "Pegasoft",
  "pegasoft": "pegasoft",
  "Pegasoft Solutions": "Pegasoft Solutions",
  "PEGASOFT": "PEGASOFT",
  "Pegasoft — Every idea engineered to matter, alongside the blue connected globe.": "Pegasoft — Κάθε ιδέα φτιαγμένη να μετράει, δίπλα στη γαλάζια διασυνδεδεμένη υδρόγειο.",
});
